module.exports = __webpack_public_path__ + "static/media/request-frames-blue.1cd56d69.svg";